import {
  LOGOUT,
  LOGOUT_SUCCESS,
  UPDATE_USER_PREFERENCES,
  UPDATE_USER_PREFERENCES_SUCCESS,
  UPDATE_USER_PREFERENCES_FAILURE,
  SWITCH_CLIENT,
} from './types';

import {
  FETCH_INITIAL_DATA_SUCCESS,
  FETCH_USER_CLIENTS_LIST_SUCCESS,
} from '../../shared/store/types';

import initialState from './initialState';

function userReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_INITIAL_DATA_SUCCESS:
      return {
        ...state,
        user: action.user,
        clients: action.clients,
      };
    case FETCH_USER_CLIENTS_LIST_SUCCESS: {
      const currentClient = action.clients.clients.find(item => item.clientId === state.user.lastClientId);
      return {
        ...state,
        clients: action.clients.clients,
        user: {
          ...state.user,
          rtpFlag: currentClient?.featureFlags?.rtpFlag?.value,
        },
      };
    }
    case LOGOUT:
      return {
        ...state,
        isLoggingOut: true,
      };
    case LOGOUT_SUCCESS:
      return {
        ...initialState,
      };
    case UPDATE_USER_PREFERENCES:
      return {
        ...state,
        isUpdatingPreferences: true,
      };
    case UPDATE_USER_PREFERENCES_SUCCESS:
      return {
        ...state,
        preferences: action.preferences,
        user: {
          ...state.user,
          ...action.preferences,
        },
        isUpdatingPreferences: false,
      };
    case UPDATE_USER_PREFERENCES_FAILURE:
      return {
        ...state,
        isUpdatingPreferences: false,
      };
    case SWITCH_CLIENT:
      return {
        ...state,
        user: {
          ...state.user,
          lastClientId: action.clientId,
        },
      };
    default:
      return state;
  }
}

export default userReducer;
